import { useCallback } from 'react';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';
import { Canvas } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Canvas';

export const useHideIntroVariant = () => {
  const { dispatch, state } = useWorkFlowCanvas();
  return useCallback(() => {
    const { nodes, edges } = Canvas.createFromState(state)
      .hideTriggerIntro()
      .convertToState();

    dispatch({
      type: 'HIDE_INTRO_VARIANT',
    });

    dispatch({
      type: 'UPDATE',
      payload: {
        nodes,
        edges,
      },
    });
  }, [dispatch, state]);
};
